@switch (pollType) {
    @case ('AgreeDisagreeQuestion') {
        <agree-disagree-question-result-bar-chart [values]="results.values" 
                                                  [chartId]="pollId"></agree-disagree-question-result-bar-chart> 
    }
    @case ('ClosedQuestion') {
        <closed-question-result-bar-chart [results]="results" 
                                          [chartId]="pollId"></closed-question-result-bar-chart>
    }
    @case ('ScaleQuestion') {
        <scale-question-result-pyramid-chart [results]="results"
                                             [chartId]="pollId"
                                             [context]="context"></scale-question-result-pyramid-chart>

    }
    @case ('FiveStarsQuestion') {
        <five-stars-question-result-chart [results]="results"></five-stars-question-result-chart>
    }
}